<template>
  <div>
    <div class="container gray-background">
      <div class="row">
        <div class="col-12 line">Czynności wykonywane podczas naprawy</div>
      </div>
      <div class="row">
        <div class="col-12" v-html="repair.primaryActivities" />
        <div class="col-12" v-html="repair.secondaryActivities" />
      </div>
      <div class="row" v-if="repair.optionalActivities">
        <div class="col-12 line">Opcjonalne czynności</div>
      </div>


      <div class="row" v-if="isCalculatedLoading">
        <div class="d-flex justify-content-center">
          <Loading />
        </div>
      </div>
      <div class="row" v-else>
        <div class="col-12">
          <ul v-if="user">
            <li
              v-for="variant in calculatedRepair.calculatedOptionalActivities"
              :key="variant.repair.id"
              class="optional-activity"
            >
              <router-link
                :to="{
                  name: 'repair-detail',
                  params: {
                    repairId: variant.repair.id,
                  },
                }"
                style="text-decoration: none"
              >
                <p class="name">{{ variant.repair.name }}</p>
                <div class="d-flex justify-content-between" v-if="variant.prices && variant.prices.estimatedMin">
                  <p class="small-text">szacowany koszt</p>
                  <p class="red-text" v-if="!variant.prices.hasPrices">
                    dane częściowe
                  </p>
                  <p class="red-text" v-else>
                    {{ thousands(variant.prices.estimatedMin) }} -
                    {{ thousands(variant.prices.estimatedMax) }} zł
                  </p>
                </div>
              </router-link>
            </li>
          </ul>
          <ul v-else>
            <li
              v-for="variant in repair.optionalActivities"
              :key="variant.id"
              class="optional-activity"
            >
              <router-link
                :to="{
                  name: 'repair-detail',
                  params: {
                    repairId: variant.id,
                  },
                }"
                style="text-decoration: none"
              >
                <p class="name">{{ variant.name }}</p>
              </router-link>
            </li>
          </ul>
        </div>
      </div>

      <div class="row">
        <div class="col-12 line">Jak długo trwa naprawa?</div>
      </div>
      <div class="row">
        <div class="col-12 mt-2">
          <ul>
            <li class="time">
              min - max:
              <span class="blue"
                >{{ repair.minTime }} - {{ repair.maxTime }} roboczogodzin</span
              >
            </li>
            <li class="time">
              przeciętnie:
              <span class="blue">{{ repair.avgTime }} roboczogodzin</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="row" v-if="repair.additionalNotes">
        <div class="col-12 additional-notes">
          <p class="bold">Uwagi:</p>
          <p v-html="repair.additionalNotes"></p>
        </div>
      </div>
    </div>
    <div class="additional-tips container">
      <div class="row">
        <div class="col-12">
          <div class="line">Dodatkowe wskazówki</div>
          <p v-html="repair.additionalTips" class="additional-tips-body"></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import Loading from "@/components/Loading";
import FootNotes from "@/components/repair-detail-components/FootNotes.vue";
import MailToUs from "@/improvementForms/MailToUs.vue";
import NotFound from "@/views/NotFound.vue";
import VariantedCost from "@/components/repair-detail-components/VariantedCost.vue";

export default {
  props: {
    repair: Object,
    calculatedRepair: Object,
    isCalculatedLoading: Boolean,
  },
  methods: {
    thousands(num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
  },
  computed: {
    ...mapGetters("accounts", ["user"]),
    ...mapGetters("cars", ["getSelectedCar"]),
  },
  components: {
    Loading,
  },
};
</script>
<style scoped>
.gray-background {
  background-color: rgba(79, 79, 79, 0.05);
  padding-top: 10px;
  padding-bottom: 10px;
}
.line {
  font-weight: bold;
  font-size: 17px;
  width: 100%;
  border-bottom: 2px solid black;
  margin-bottom: 18px;
}

.light-text {
  font-size: 18px;
  color: #797979;
}
.smaller {
  font-size: 14px;
  padding: 0;
}

.optional-activity .name {
  color: black;
  text-decoration: underline;
  font-size: 16px;
}

.optional-activity .small-text {
  font-size: 13px;
  color: #797979;
}

.optional-activity .red-text {
  font-size: 12px;
  color: #ff2663;
}

.blue {
  color: #0072db;
  font-weight: bold;
}

.time {
  font-size: 18px;
}

.bold {
  font-weight: bold;
  margin: 0;
}

.additional-notes {
  font-size: 16px;
}

.additional-tips {
  background-color: rgba(0, 114, 219, 0.1);
  padding-top: 18px;
  padding-bottom: 30px;
}

.additional-tips .additional-tips-body {
  margin-left: 13px;
}
</style>
